import type { JSX } from 'react';
import { useColorPickerState } from './ColorPickerContext';
import { ColorNameOrHexCode } from './ColorNameOrHexCode';

export type ValueNameOrHexCodeProps = object;

/**
 * Displays the name of the current color (if it matches a known color name)
 * or its hex code. Reads the current value from ColorPicker context.
 */
export const ValueNameOrHexCode = (props: ValueNameOrHexCodeProps): JSX.Element => {
  const { valueAsHex } = useColorPickerState();

  return (
    <ColorNameOrHexCode
      {...props}
      hexCode={valueAsHex}
    />
  );
};

ValueNameOrHexCode.displayName = 'ValueNameOrHexCode';
